<ng-container *hasPermission="['APP_SETTINGS_READ', 'APP_SETTINGS_ALL','SAFESTREET_ADMIN']">
    <div class="container-fluid">
        <div class="page-title">
            <h2>Parametri app palmare</h2>
        </div>
        <div class="section-container" *ngIf="appSettingsForm">
            <form [formGroup]="appSettingsForm" (ngSubmit)="onSave()">
                <div class="row">
                    <div class="col-12 mb-4" *ngFor="let group of groupedAppSettings">
                        <div class="card h-100">
                            <div class="card-header bg-secondary text-white">{{computeComponentLabel(group.component)}}</div>
                            <div class="card-body">
                                <div class="row mb-3 align-items-center" *ngFor="let appSetting of group.settings">
                                    <div class="col-6">{{appSetting.description}}</div>
                                    <div class="col-6">
                                        @if (appSetting.type === 'integer') {
                                        <input type="number" [id]="appSetting.keyId" [name]="appSetting.keyId!"
                                            [formControlName]="appSetting.keyId!" class="form-control">
                                        }
                                        @else if(appSetting.type === 'string'){
                                        <input type="text" [id]="appSetting.keyId" [name]="appSetting.keyId!"
                                            [formControlName]="appSetting.keyId!" class="form-control">
                                        }
                                        @else if(appSetting.type === 'boolean'){
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" [id]="appSetting.keyId"
                                                [name]="appSetting.keyId!" [formControlName]="appSetting.keyId!">
                                        </div>
                                        } @else if(appSetting.type === 'double'){
                                        <input type="text" [id]="appSetting.keyId" [name]="appSetting.keyId!"
                                            [formControlName]="appSetting.keyId!" class="form-control">

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-end">
                    <button *hasPermission="['APP_SETTINGS_UPDATE', 'APP_SETTINGS_ALL','SAFESTREET_ADMIN']" type="submit"
                        class="btn btn-primary">Salva</button>
                </div>
            </form>
        </div>
    </div>
</ng-container>